<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-container fluid>
      <!-- <div class="addingItemComponentForm"> -->
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Datum"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="danaValute"
              label="Valuta"
              type="number"
              suffix="dana"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @change="popuniDatumValute"
              min="0"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menuKupovine"
              v-model="menuKupovine"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormattedKupovine"
                label="Datum valute"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="dateKupovine = parseDate(dateFormattedKupovine)"
              ></v-text-field>
              <v-date-picker
                v-model="dateKupovine"
                no-title
                @input="menuKupovine = false"
              ></v-date-picker>
              <!-- :max="maxDate" -->
            </v-menu>
          </v-flex>
          <v-flex xs5 pa-2>
            <v-autocomplete
              ref="element_1"
              v-model="company_to_select"
              :items="company_to_items"
              item-value="id"
              item-text="name"
              label="Dobavljač"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              return-object
              lazy-validation
              :disabled="!edit_form"
              style="margin-right: 40px !important"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 20px !important;
              max-width: 40px !important;
              margin-left: -40px !important;
            "
          >
            <v-icon
              slot="activator"
              @click="otvoriSifarnik"
              style="color: #018389; padding-left: 0px; font-weight: bold"
              title="Dodavanje dobavljača"
              >add</v-icon
            >
          </v-flex>
        </v-layout>
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs5 pa-2>
            <!-- <v-text-field
              v-model="give"
              label="Predao"
              persistent-hint
              return-object
            ></v-text-field> -->

            <v-autocomplete
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Predao"
              persistent-hint
              :disabled="!edit_form"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-2> </v-flex>
          <v-flex xs5 pa-2 style="text-align: right">
            <v-autocomplete
              v-model="receive_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit_form"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- <v-flex xs12 pa-2>
            <v-textarea v-model="opis" name="input-5-1" class="Description" label="Opis"></v-textarea>
          </v-flex> -->
          <v-flex xs12 pa-2>
            <v-text-field
              v-model="opis"
              label="Opis"
              :disabled="!edit_form"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 pa-2 style="text-align: center">
            <v-btn
              id="HistoryButton"
              @click="otvoriModal"
              v-if="edit_form && !executed_document"
            >
              <p>
                <v-icon>close</v-icon>
              </p>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-flex style="overflow: auto">
            <v-data-table
              :headers="headers_modal"
              :items="items_modal_pom"
              hide-actions
              class="elevation-1"
              :pagination.sync="pagination"
            >
            <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.align === 'left' ? 'text-xs-left' : 'text-xs-center']"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                {{ header.text }}
              </th>
            </tr>
          </template>
              <template slot="items" slot-scope="props_modal">
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 30%;
                  "
                >
                  {{ props_modal.item.articleId.name }}
                </td>
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 15%;
                  "
                >
                  {{ props_modal.item.lot }}
                </td>
                <!-- <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                  "
                >
                  {{
                    formatDateTime(props_modal.item.bottlingOrProductionDate)
                  }}
                </td> -->
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 15%;
                  "
                  v-if="
                    typeof props_modal.item.validTo !== undefined &&
                    props_modal.item.validTo !== null
                  "
                >
                  {{ formatDateTime(props_modal.item.validTo) }}
                </td>
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 15%;
                  "
                  v-else
                >
                  {{ "-" }}
                </td>
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 10%;
                  "
                >
                  {{
                    Math.round(props_modal.item.price * 100) / 100 +
                    " " +
                    props_modal.item.currency.mark
                  }}
                </td>
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 10%;
                  "
                >
                  {{
                    props_modal.item.quantity +
                    " " +
                    props_modal.item.quantityUnitOfMeasure.mark.replace(
                      "psc",
                      "kom"
                    )
                  }}
                </td>

                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                    width: 10%;
                  "
                >
                  {{
                    currencyFormatDE(props_modal.item.value) +
                    " " +
                    props_modal.item.currency.mark
                  }}
                </td>
                <td
                  class="DataTable__ButtonHolder"
                  style="text-align: center; padding-left: 0px !important"
                >
                  <img
                    v-if="edit_form"
                    class="DataTable__Button"
                    title="Izmena"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    v-else
                    class="DataTable__Button"
                    title="Pregled"
                    src="../assets/icons/zatabele/ico-view.png"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItemModal(props_modal.item)"
                    v-if="edit_form && !executed_document"
                  />
                </td>
              </template>
              <template slot="no-data">
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            style="
              text-align: right;
              margin-bottom: 0px;
              margin-right: 0px;
              padding-top: 15px;
              padding-right: 12%;
              font-size: 13px;
            "
          >
            Ukupno: {{ currencyFormatDE(ukupna_vrednost) }} RSD.
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            style="text-align: right; margin-bottom: 0px; padding-top: 15px"
          >
            <v-btn
              :disabled="!valid"
              @click="submit"
              class="AppButtonFilled"
              v-if="edit_form"
              >Sačuvaj</v-btn
            >
            <v-btn
              id="Odustani_dugme"
              @click="clear"
              class="AppButtonOutlined"
              v-if="edit_form"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>

      <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
        <v-container>
          <div class="DataTable">
            <v-form ref="form_modal" v-model="validModal" lazy-validation>
              <a
                class="closeModalInModalBtn"
                @click.prevent="closeModalInModal"
              >
                <v-icon>close</v-icon>
              </a>
              <!-- /.closeModalBtn -->
              <v-layout row wrap>
                <v-flex xs6 pa-2>
                  <v-autocomplete
                    v-model="article_to_select"
                    :items="article_to_items"
                    item-text="name"
                    item-value="id"
                    label="Repromaterijal"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeArticle"
                    :disabled="!edit_form"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs1
                  pa-2
                  style="
                    padding-top: 20px !important;
                    padding-left: 0px !important;
                    padding-top: 20px !important;
                  "
                >
                  <v-icon
                    slot="activator"
                    @click="otvoriSifarnik2"
                    style="color: #018389; padding-left: 0px; font-weight: bold"
                    title="Dodavanje repromaterijala"
                    v-if="edit_form"
                    >add</v-icon
                  >
                </v-flex>
              </v-layout>
            </v-form>
            <v-form ref="form_nevalidiraj" v-model="validModal" lazy-validation>
              <v-layout row wrap>
                <v-flex xs6 pa-2>
                  <v-text-field
                    ref="element_lot"
                    v-model="lot"
                    label="Lot"
                    persistent-hint
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-menu
                    ref="menuModal"
                    v-model="menuModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    :disabled="!edit_form"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedModal"
                      label="Proizvedeno"
                      readonly
                      @blur="dateModal = parseDate(dateFormattedModal)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateModal"
                      no-title
                      @input="menuModal = false"
                      :max="maxDate"
                      v-on:change="changeDate"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateModal = null;
                        $refs.menuModal.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs1>
                  <v-menu
                    ref="menu1Modal"
                    :close-on-content-click="false"
                    v-model="menu1Modal"
                    :nudge-right="0"
                    transition="scale-transition"
                    lazy
                    offset-y
                    :disabled="!edit_form"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="timeModal"
                      label=""
                      readonly
                    ></v-text-field>
                    <v-time-picker
                      v-model="timeModal"
                      ref="picker"
                      format="24hr"
                      full-width
                      landscape
                      class="mt-3"
                      :allowed-minutes="allowedStep"
                      v-on:change="postavTimeModal(timeModal)"
                    >
                      <v-spacer></v-spacer>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-menu
                    ref="menuVazenja"
                    v-model="menuVazenja"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    :disabled="!edit_form"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedVazenja"
                      label="Važi do"
                      readonly
                      @blur="dateVazenja = parseDate(dateFormattedVazenja)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateVazenja"
                      no-title
                      @input="menuVazenja = false"
                      :min="minDate"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateVazenja = null;
                        $refs.menuVazenja.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs1>
                  <v-menu
                    ref="menu1Vazenja"
                    :close-on-content-click="false"
                    v-model="menu1Vazenja"
                    :nudge-right="0"
                    transition="scale-transition"
                    lazy
                    offset-y
                    :disabled="!edit_form"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="timeVazenja"
                      label=""
                      readonly
                    ></v-text-field>
                    <v-time-picker
                      v-model="timeVazenja"
                      ref="picker"
                      format="24hr"
                      full-width
                      landscape
                      class="mt-3"
                      :allowed-minutes="allowedStep"
                      v-on:change="postavTimeVazenja(timeVazenja)"
                    >
                      <v-spacer></v-spacer>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
            <v-form ref="form_modal_1" v-model="validModal" lazy-validation>
              <v-layout row wrap>
                <v-flex xs2 pa-2>
                  <v-text-field
                    v-model="quantity"
                    label="Količina"
                    type="number"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeVrednost_Kolicina"
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-autocomplete
                    v-model="jm_select"
                    :items="jm_items"
                    :item-text="getFieldTextJM"
                    item-value="id"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="JM"
                    required
                    persistent-hint
                    return-object
                    :disabled="true"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs2 pa-2> </v-flex>
                <v-flex xs2 pa-2>
                  <v-text-field
                    v-model="cena"
                    label="Cena"
                    type="number"
                    required
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    v-on:change="changeVrednost_Cena"
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 style="padding-top: 23px; font-size: 16px">
                  RSD
                </v-flex>
                <!-- <v-flex xs2 pa-2>
                  <v-autocomplete
                    v-model="jm_valuta"
                    :items="currency_items"
                    item-text="mark"
                    item-value="id"
                    label="Valuta"
                    persistent-hint
                    return-object
                    :disabled="true"
                  ></v-autocomplete>
                </v-flex> -->
                <v-flex xs2 pa-2>
                  <v-text-field
                    v-model="vrednost"
                    label="Vrednost"
                    type="number"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1 style="padding-top: 23px; font-size: 16px">
                  RSD
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs12
                  style="
                    text-align: right;
                    margin-bottom: 0px;
                    padding-top: 15px;
                  "
                >
                  <v-btn
                    :disabled="!validModal"
                    @click="submit_modal"
                    class="AppButtonFilled"
                    v-if="edit_form"
                    >Sačuvaj</v-btn
                  >
                  <v-btn
                    @click="clear_modal"
                    class="AppButtonOutlined"
                    v-if="edit_form"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>
      <TokenComponent ref="frmtoken" />
    </v-container>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <Company
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></Company>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije2"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <AdditiveComponent
              @close="handleDataCloseOperacije2($event)"
              :operationType="operacija2"
            ></AdditiveComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

import Company from "../views/Company.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import AdditiveComponent from "../views/AdditiveItemComponentPom.vue";

export default {
  name: "AddingItem",
  components: {
    TokenComponent,
    AdditiveComponent,
    Company,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    ukupna_vrednost: 0,
    danaValute: undefined,
    menu: "",
    menu1: "",
    time: "",
    date: null,
    menuKupovine: "",
    dateKupovine: null,
    valid: true,
    validModal: true,
    menuModal: "",
    menu1Modal: "",
    timeModal: "",
    dateModal: null,
    menuVazenja: "",
    menu1Vazenja: "",
    timeVazenja: "",
    dateVazenja: null,
    dateFormatted: null,
    dateFormattedKupovine: null,
    dateFormattedModal: null,
    dateFormattedVazenja: null,
    naziv: "",
    ID: 0,
    type: "input",
    input: true,
    receive_id: 0,
    opis: "",
    employee_to_items: [],
    article_to_items: [],
    article_to_select: 0,
    give_to_select: 0,
    give: undefined,
    receive_to_select: 0,
    company_to_select: 0,
    company_to_items: [],
    opis: "",
    dialogNote: false,
    index_izmene: -1,
    izmena_modal: true,
    vrednost_za_umanjenje: 0,
    quantity: undefined,
    jm_select: "",
    jm_items: [],
    // currency_items: [],
    cena: undefined,
    // jm_valuta: undefined,
    porez: 0,
    vrednost: 0,
    lot: "",
    items_modal: [],
    items_modal_pom: [],
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000
    },
    headers_modal: [
      { text: "Repromaterijal", value: "articleId.name", align: "center" },
      { text: "Lot", value: "lot", align: "center" },
      // { text: "Proizvedeno", value: "bottlingOrProductionDate" },
      { text: "Važi do", value: "validTo", align: "center" },
      { text: "Cena", value: "price", align: "center" },
      { text: "Količina", value: "quantity", align: "center" },
      // { text: "JM", value: "width" },
      { text: "Vrednost", value: "value", align: "center" },
      { text: "Funkcije", value: "funkcije", align: "center", sortable: false },
    ],
    warehouseID: 0,
    warehouseType: "",
    edit_form: true,
    executed_document: false,
    number: "",
    itemId: 0,
    min_date: undefined,
    operacija: undefined,
    dialogNote_operacije: false,
    dialogNote_operacije2: false,
    operacija2: undefined,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateKupovine(val) {
      this.dateFormattedKupovine = this.formatDate1(this.dateKupovine);
    },
    dateModal(val) {
      this.dateFormattedModal = this.formatDate1(this.dateModal);
    },
    dateVazenja(val) {
      this.dateFormattedVazenja = this.formatDate1(this.dateVazenja);
    },
    timeModal(val) {
      this.timeModal = val;
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    minDate: {
      // getter
      get: function () {
        return this.min_date;
      },
      // setter
      set: function (newValue) {
        this.min_date = newValue;
      },
    },
  },
  methods: {
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    handleDataCloseOperacije2: function (e) {
      debugger;

      this.getAllArticles(e.name);

      this.dialogNote_operacije2 = false;
    },
    otvoriSifarnik2(event) {
      this.operacija2 = "Magacin";

      this.dialogNote_operacije2 = true;
    },
    otvoriSifarnik(event) {
      this.operacija = "Maka";
      this.dialogNote_operacije = true;
    },
    handleDataCloseOperacije: function (e) {
      this.getAllSellers();
      this.dialogNote_operacije = false;
    },
    getFieldTextJM(item) {
      let tekst = item.mark;

      if (item.mark === "psc") tekst = "kom";

      return tekst;
    },
    popuniDatumValute(e) {
      const today = new Date(this.date);
      today.setDate(today.getDate() + Number(e));

      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.dateKupovine = [Year, Month, Day].join("-");
    },
    postavTimeModal(timeModal) {
      // alert(timeModal);
      // this.timeModal = timeModal;
      this.timeModal = timeModal;

      this.menu1Modal = false;
    },
    postavTimeVazenja(timeModal) {
      // alert(timeModal);
      // this.timeModal = timeModal;
      this.timeVazenja = timeModal;

      this.menu1Vazenja = false;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      this.dateKupovine = [Year, Month, Day].join("-");
    },
    setTimeModal() {
      this.timeModal = "00:00";
      this.timeVazenja = "00:00";
    },
    setDateModal() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.dateModal = [Year, Month, Day].join("-");
      this.dateVazenja = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    getAllEmployees() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.employee_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSellers() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/company/all/sellers",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.company_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/company/all/sellers",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.company_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/unit_of_measure/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.jm_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.jm_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getAllArticles(aditivZaSelektovanje) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv/all/with_default_unit_of_measure",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.article_to_items = response.data;

          if (
            aditivZaSelektovanje !== undefined &&
            aditivZaSelektovanje !== null
          ) {
            let ind = this.article_to_items.findIndex(
              (x) => x.name === aditivZaSelektovanje
            );

            this.article_to_select = this.article_to_items[ind];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv/all/with_default_unit_of_measure",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items = response.data;

                      if (
                        aditivZaSelektovanje !== undefined &&
                        aditivZaSelektovanje !== null
                      ) {
                        let ind = this.article_to_items.findIndex(
                          (x) => x.name === aditivZaSelektovanje
                        );

                        this.article_to_select = this.article_to_items[ind];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    // getAllValute() {
    //   this.$http
    //     .get(this.globalServiceLocation + this.globalPort + "/currency/all", {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer  " + localStorage.getItem("user-token"),
    //       },
    //     })
    //     .then((response) => {
    //       console.log(response.data);

    //       this.currency_items = response.data;

    //     })
    //     .catch((e) => {
    //       // // console.log(e.response);

    //       if (!e.response) {
    //         alert(
    //           this.$t("error.message")
    //         );
    //       } else {
    //         if (e.response.status === 401) {
    //           this.$refs.frmtoken
    //             .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
    //             .then((result) => {
    //               // // console.log(result);
    //               // // console.log("Novi token - " + localStorage.getItem("user-token"));

    //               this.$http
    //                 .get(
    //                   this.globalServiceLocation +
    //                     this.globalPort +
    //                     "/currency/all",
    //                   {
    //                     headers: {
    //                       "Content-Type": "application/json",
    //                       Authorization:
    //                         "Bearer  " + localStorage.getItem("user-token"),
    //                     },
    //                   }
    //                 )
    //                 .then((response) => {
    //                   // // console.log(response.data);

    //                   this.currency_items = response.data;
    //                 })
    //                 .catch((e) => {
    //                   // // console.log(e.response);

    //                   let pomError = readJSON(e.response.data.message);
    //                   alert(pomError);
    //                 });
    //             });
    //         } else {
    //           let pomError = readJSON(e.response.data.message);
    //           alert(pomError);
    //         }
    //       }
    //     });
    // },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    changeArticle(a) {
      if (typeof a !== "undefined") this.jm_select = a.unitOfMeasure;
    },
    changeVrednost_Kolicina(a) {
      if (typeof a !== "undefined" && typeof this.cena !== "undefined") {
        this.vrednost = Math.round(a * this.cena * 100) / 100;
      } else this.vrednost = undefined;
    },
    changeVrednost_Cena(a) {
      if (typeof a !== "undefined" && typeof this.quantity !== "undefined") {
        this.vrednost = Math.round(a * this.quantity * 100) / 100;
      } else this.vrednost = undefined;
    },
    otvoriModal() {
      this.dialogNote = true;
      this.getAllArticles();
      this.getAllJediniceMere();
      // this.getAllValute();

      this.clear_modal();
    },
    changeDate(a) {
      this.min_date = a;

      // this.dateVazenja = null;
      this.$refs.menu.save(a);
    },
    closeModalInModal() {
      this.dialogNote = false;
    },
    submit_modal() {
      if (
        this.$refs.form_modal.validate() &&
        this.$refs.form_modal_1.validate()
      ) {
        let pronadjiObjNovi;

        pronadjiObjNovi = this.items_modal_pom.findIndex(
          (item1) =>
            item1.articleId.id === this.article_to_select.id &&
            item1.lot === this.lot
        );

        if (pronadjiObjNovi !== -1 && this.index_izmene === -1)
          alert("Izabrani artikal i lot već se nalaze u listi.");
        // else if (
        //   this.index_izmene !== -1 &&
        //   this.index_izmene !== pronadjiObjNovi &&
        //   pronadjiObjNovi !== -1
        // )
        //   alert("Izabrani artikal i lot već se nalaze u listi.");
        else {
          var complexPouringAdditiv;

          var pom_jm_to_select;

          if (typeof this.jm_select !== "undefined" && this.jm_select !== "") {
            if (typeof this.jm_select.id === "undefined")
              pom_jm_to_select = this.jm_select;
            else pom_jm_to_select = this.jm_select.id;
          }

          var complexObjectUnitOfMeasure = {
            id: pom_jm_to_select,
          };

          var pom_artikal;

          if (
            typeof this.article_to_select !== "undefined" &&
            this.article_to_select !== ""
          ) {
            if (typeof this.article_to_select.id === "undefined")
              pom_artikal = this.article_to_select;
            else pom_artikal = this.article_to_select.id;
          }

          var complexPouringAdditivPom;

          if (
            (this.dateModal === undefined || this.dateModal === null) &&
            (this.dateVazenja === undefined || this.dateVazenja === null)
          ) {
            if (this.itemId !== 0 && this.itemId !== undefined) {
              complexPouringAdditiv = {
                id: this.itemId,
                articleId: pom_artikal,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                // validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };
              complexPouringAdditivPom = {
                id: this.itemId,
                articleId: this.article_to_select,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: null,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            } else {
              complexPouringAdditiv = {
                articleId: pom_artikal,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                // validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };
              complexPouringAdditivPom = {
                articleId: this.article_to_select,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: null,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            }
          } else if (this.dateModal === undefined || this.dateModal === null) {
            if (this.itemId !== 0 && this.itemId !== undefined) {
              complexPouringAdditiv = {
                id: this.itemId,
                articleId: pom_artikal,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };

              complexPouringAdditivPom = {
                id: this.itemId,
                articleId: this.article_to_select,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            } else {
              complexPouringAdditiv = {
                articleId: pom_artikal,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };

              complexPouringAdditivPom = {
                articleId: this.article_to_select,
                lot: this.lot,
                // bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            }
          } else if (
            this.dateVazenja === undefined ||
            this.dateVazenja === null
          ) {
            if (this.itemId !== 0 && this.itemId !== undefined) {
              complexPouringAdditiv = {
                id: this.itemId,
                articleId: pom_artikal,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                // validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };
              complexPouringAdditivPom = {
                id: this.itemId,
                articleId: this.article_to_select,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: null,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            } else {
              complexPouringAdditiv = {
                articleId: pom_artikal,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                // validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };
              complexPouringAdditivPom = {
                articleId: this.article_to_select,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: null,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            }
          } else {
            if (this.itemId !== 0 && this.itemId !== undefined) {
              complexPouringAdditiv = {
                id: this.itemId,
                articleId: pom_artikal,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };

              complexPouringAdditivPom = {
                id: this.itemId,
                articleId: this.article_to_select,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            } else {
              complexPouringAdditiv = {
                articleId: pom_artikal,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                vat: this.porez,
                price: this.cena,
                currency: {
                  id: 1,
                },
              };

              complexPouringAdditivPom = {
                articleId: this.article_to_select,
                lot: this.lot,
                bottlingOrProductionDate: this.dateModal + "T" + this.timeModal,
                validTo: this.dateVazenja + "T" + this.timeVazenja,
                quantity: Number(this.quantity),
                quantityUnitOfMeasure: this.jm_select,
                vat: this.porez,
                price: this.cena,
                currency: { id: 1, mark: "RSD" },
                value: this.vrednost,
              };
            }
          }

          if (pom_jm_to_select !== null)
            if (this.ID !== 0)
              if (this.index_izmene !== -1) {
                // ovde treba da ide poziv nove procedure za izmenu
                this.edit_modal(complexPouringAdditiv, "INPUT");
              } else {
                // ovde treba da ide poziv nove procedure za unos stavke
                this.add_modal(complexPouringAdditiv, "INPUT");
              }
            else {
              if (this.index_izmene !== -1) {
                // this.items_modal.splice(this.index_izmene, 1);
                // this.items_modal_pom.splice(this.index_izmene, 1);

                this.items_modal[this.index_izmene] = complexPouringAdditiv;
                this.items_modal_pom[this.index_izmene] = complexPouringAdditivPom;
              }
              else{
                this.items_modal.push(complexPouringAdditiv);
                this.items_modal_pom.push(complexPouringAdditivPom);
              }

              // this.items_modal.push(complexPouringAdditiv);
              // this.items_modal_pom.push(complexPouringAdditivPom);

              this.ukupna_vrednost = this.ukupna_vrednost + this.vrednost - this.vrednost_za_umanjenje;

              this.clear_modal();
            }
          else
            alert(
              "Za izabrani repromaterijal u šifarnicima nije izabrana odgovarajuća grupa jedinice mere."
            );
        }
      }
    },
    vrati_objekat(newObject, type) {
      var pom_company_to_select;
      var pomArray = [];
      pomArray.push(newObject);

      if (
        typeof this.company_to_select !== "undefined" &&
        this.company_to_select !== ""
      ) {
        if (typeof this.company_to_select.id === "undefined")
          pom_company_to_select = this.company_to_select;
        else pom_company_to_select = this.company_to_select.id;
      }

      var complexObjectCompany = {
        id: pom_company_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== "" &&
        this.give_to_select !== null
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (this.ID !== 0) {
        if (this.give_to_select === undefined || this.give_to_select === null)
          complexInput = {
            id: this.ID,
            warehouse: complexObjectWareHouse,
            date: this.date + "T" + this.time,
            company: complexObjectCompany,
            payingDate: this.dateKupovine + "T00:00:00",
            type: type,
            receive: complexObjectReceive,
            input: true,
            description: this.opis,
            warehouseInputOutputItems: pomArray,
          };
        else
          complexInput = {
            id: this.ID,
            warehouse: complexObjectWareHouse,
            date: this.date + "T" + this.time,
            company: complexObjectCompany,
            payingDate: this.dateKupovine + "T00:00:00",
            type: type,
            give: complexObjectGive,
            receive: complexObjectReceive,
            input: true,
            description: this.opis,
            warehouseInputOutputItems: pomArray,
          };
      } else {
        if (this.give_to_select === undefined || this.give_to_select === null)
          complexInput = {
            warehouse: complexObjectWareHouse,
            date: this.date + "T" + this.time,
            company: complexObjectCompany,
            payingDate: this.dateKupovine + "T00:00:00",
            type: type,
            receive: complexObjectReceive,
            input: true,
            description: this.opis,
            warehouseInputOutputItems: pomArray,
          };
        else
          complexInput = {
            warehouse: complexObjectWareHouse,
            date: this.date + "T" + this.time,
            company: complexObjectCompany,
            payingDate: this.dateKupovine + "T00:00:00",
            type: type,
            give: complexObjectGive,
            receive: complexObjectReceive,
            input: true,
            description: this.opis,
            warehouseInputOutputItems: pomArray,
          };
      }

      return complexInput;
    },
    edit_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type);
      let url;

      if (!this.executed_document) url = "/warehouse_input_output_item/update";
      else url = "/warehouse_input_output/update_executed";

      this.$http
        .put(this.globalServiceLocation + this.globalPort + url, complexInput, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + url,
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnikExcecuted() {
      var pom_company_to_select;

      if (
        typeof this.company_to_select !== "undefined" &&
        this.company_to_select !== ""
      ) {
        if (typeof this.company_to_select.id === "undefined")
          pom_company_to_select = this.company_to_select;
        else pom_company_to_select = this.company_to_select.id;
      }

      var complexObjectCompany = {
        id: pom_company_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== "" &&
        this.give_to_select !== null
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (this.give_to_select !== undefined)
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
        };
      else
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update_executed",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          if (this.warehouseType === "bottled_wine")
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";
          else
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";

          // if (confirm(poruka))
          //   this.prijemDokumenta(this.ID);
          // else
          //   this.dialogNote = false;

          // alert(poruka);

          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update_executed",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";
                      else
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";

                      // if (confirm(poruka))
                      //   this.prijemDokumenta(this.ID);
                      // else
                      //   this.dialogNote = false;

                      // alert(poruka);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    add_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type);

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output_item/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output_item/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    clear_modal() {
      this.index_izmene = -1;

      this.$refs.form_modal.reset();
      this.$refs.form_modal_1.reset();
      this.$refs.element_lot.reset();

      this.lot = undefined;

      this.izmena_modal = false;
      this.vrednost_za_umanjenje = 0;
      // alert('ocisti modal')

      this.setTimeModal();
      // this.setDateModal();

      this.dateModal = undefined;
      this.dateVazenja = undefined;

      this.min_date = undefined;

      this.itemId = 0;
    },
    clearInit() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.element_1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      // document.getElementById("naslov").innerText = "Ulaz";
    },
    wait: function (ms) {
      var start = Date.now(),
        now = start;
      while (now - start < ms) {
        now = Date.now();
      }
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.element_1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      document.getElementById("naslov").innerText = "Prijem";

      this.ukupna_vrednost = 0;
      this.executed_document = false;
    },
    deleteItemModal(item) {
      if (item.id !== undefined) {
        let url = "/warehouse_input_output_item/delete/" + item.id;

        this.$http
          .delete(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            // // // console.log(response);
            alert("Stavka je uspešno obrisana.");
            this.getAllItem(this.ID);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation + this.globalPort + url,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // // console.log(response);
                        alert("Stavka je uspešno obrisana.");
                        this.getAllItem(this.ID);
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      } else {
        const index = this.items_modal_pom.indexOf(item);
        this.items_modal_pom.splice(index, 1);

        this.items_modal.splice(index, 1);
      }
    },
    newSifarnik() {
      var pom_company_to_select;

      if (
        typeof this.company_to_select !== "undefined" &&
        this.company_to_select !== ""
      ) {
        if (typeof this.company_to_select.id === "undefined")
          pom_company_to_select = this.company_to_select;
        else pom_company_to_select = this.company_to_select.id;
      }

      var complexObjectCompany = {
        id: pom_company_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== "" &&
        this.give_to_select !== null
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (this.give_to_select === undefined || this.give_to_select === null)
        complexInput = {
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
          warehouseInputOutputItems: this.items_modal,
        };
      else
        complexInput = {
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
          warehouseInputOutputItems: this.items_modal,
        };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          let naslov = document.getElementById("naslov").innerText;
          document.getElementById("naslov").innerText =
            naslov + " " + response.data.documentNumber;

          setTimeout(() => {
            this.wait(500);
            if (this.warehouseType === "bottled_wine")
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite prijem vina na stanje magacina?";
            else
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite prijem materijala na stanje magacina?";

            confirm(poruka) && this.prijemDokumenta(response.data.id);

            this.clear();
          }, 10);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      let naslov = document.getElementById("naslov").innerText;
                      document.getElementById("naslov").innerText =
                        naslov + " " + response.data.documentNumber;

                      setTimeout(() => {
                        this.wait(500);
                        if (this.warehouseType === "bottled_wine")
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite prijem vina na stanje magacina?";
                        else
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite prijem materijala na stanje magacina?";

                        confirm(poruka) &&
                          this.prijemDokumenta(response.data.id);

                        this.clear();
                      }, 10);
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    prijemDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokument je uspešno izvršen.");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokument je uspešno izvršen.");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      // alert("Izmena");

      var pom_company_to_select;

      if (
        typeof this.company_to_select !== "undefined" &&
        this.company_to_select !== ""
      ) {
        if (typeof this.company_to_select.id === "undefined")
          pom_company_to_select = this.company_to_select;
        else pom_company_to_select = this.company_to_select.id;
      }

      var complexObjectCompany = {
        id: pom_company_to_select,
      };

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexObjectReceive = {
        id: pom_receive_to_select,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== "" &&
        this.give_to_select !== null
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (this.give_to_select === undefined || this.give_to_select === null)
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
          warehouseInputOutputItems: this.items_modal,
        };
      else
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          company: complexObjectCompany,
          payingDate: this.dateKupovine + "T00:00:00",
          type: "INPUT",
          give: complexObjectGive,
          receive: complexObjectReceive,
          input: true,
          description: this.opis,
          warehouseInputOutputItems: this.items_modal,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          if (this.warehouseType === "bottled_wine")
            poruka =
              "Uspesno je izmenjen dokument broj " +
              this.number +
              ". Da li želite da izvršite prijem vina na stanje magacina?";
          else
            poruka =
              "Uspesno je izmenjen dokument broj " +
              this.number +
              ". Da li želite da izvršite prijem materijala na stanje magacina?";

          confirm(poruka) && this.prijemDokumenta(this.ID);

          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Uspesno je izmenjen dokument broj " +
                          this.number +
                          ". Da li želite da izvršite prijem vina na stanje magacina?";
                      else
                        poruka =
                          "Uspesno je izmenjen dokument broj " +
                          this.number +
                          ". Da li želite da izvršite prijem materijala na stanje magacina?";

                      confirm(poruka) && this.prijemDokumenta(this.ID);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    brisanjeDokumenta(id, pomBroj) {},
    editItemModal(item) {
      this.izmena_modal = true;

      this.index_izmene = this.items_modal_pom.indexOf(item);

      this.dialogNote = true;

      if (typeof item.id !== undefined)
        if (item.id !== null) this.itemId = item.id;

      this.article_to_select = item.articleId;
      this.lot = item.lot;

      if (
        item.bottlingOrProductionDate !== null &&
        item.bottlingOrProductionDate !== undefined
      ) {
        this.dateModal = item.bottlingOrProductionDate.split("T")[0];
        this.timeModal = this.formatTime(
          item.bottlingOrProductionDate.split("T")[1]
        );
      } else this.timeModal = this.formatTime("00:00");

      if (item.validTo !== null && item.validTo !== undefined) {
        this.dateVazenja = item.validTo.split("T")[0];
        this.timeVazenja = this.formatTime(item.validTo.split("T")[1]);
      } else this.timeVazenja = this.formatTime("00:00");

      this.quantity = Math.round(item.quantity * 100) / 100;

      // this.jm_select = item.quantityUnitOfMeasure;
      this.porez = item.vat;
      this.cena = item.price;
      // this.jm_valuta = item.currency;

      this.vrednost_za_umanjenje = item.value;

      this.vrednost = Math.round(item.value * 100) / 100;
    },
    submit() {
      if (this.$refs.form.validate() && this.prveraDobavljaca())
        if (this.items_modal.length < 1)
          alert("Niste izabrali ni jednu stavku dokumenta/artikal.");
        else {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") {
              if (this.executed_document) this.changeSifarnikExcecuted();
              else this.changeSifarnik();
            } else this.newSifarnik();
          }, 1000);
        }
    },
    prveraDobavljaca() {
      let odgovor = false;

      if (this.$refs.element_1.validate()) odgovor = true;
      else this.company_to_select = 0;

      return odgovor;
    },
    getAllItem(id) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.ID = response.data.id;
          this.give_to_select = response.data.give;
          this.receive_to_select = response.data.receive;
          this.company_to_select = response.data.company;
          this.opis = response.data.description;
          this.date = response.data.date.split("T")[0];
          this.time = this.formatTime(response.data.date.split("T")[1]);

          this.items_modal = [];
          this.items_modal_pom = [];

          let complexPouringAdditiv;
          let complexPouringAdditivPom;

          let _this = this;
          this.ukupna_vrednost = 0;

          response.data.warehouseInputOutputItems.forEach(function (element) {
            console.log(element);

            complexPouringAdditiv = {
              id: element.id,
              articleId: element.articleId,
              lot: element.lot,
              bottlingOrProductionDate: element.bottlingOrProductionDate,
              validTo: element.validTo,
              quantity: Number(element.quantity),
              quantityUnitOfMeasure: {
                id: element.quantityUnitOfMeasure.id,
              },
              vat: element.vat,
              price: element.price,
              currency: {
                id: element.currency.id,
              },
            };

            complexPouringAdditivPom = {
              id: element.id,
              articleId: {
                id: element.articleId,
                name: element.materialName,
                unitOfMeasure: element.quantityUnitOfMeasure,
              },
              lot: element.lot,
              bottlingOrProductionDate: element.bottlingOrProductionDate,
              validTo: element.validTo,
              quantity: Number(element.quantity),
              quantityUnitOfMeasure: element.quantityUnitOfMeasure,
              vat: element.vat,
              price: element.price,
              currency: element.currency,
              value: element.quantity * element.price,
            };

            _this.items_modal.push(complexPouringAdditiv);
            _this.items_modal_pom.push(complexPouringAdditivPom);

            _this.ukupna_vrednost =
              _this.ukupna_vrednost + element.quantity * element.price;
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ID = response.data.id;
                      this.give_to_select = response.data.give;
                      this.receive_to_select = response.data.receive;
                      this.company_to_select = response.data.company;
                      this.opis = response.data.description;
                      this.date = response.data.date.split("T")[0];
                      this.time = this.formatTime(
                        response.data.date.split("T")[1]
                      );

                      this.items_modal = [];
                      this.items_modal_pom = [];

                      let complexPouringAdditiv;
                      let complexPouringAdditivPom;

                      let _this = this;

                      response.data.warehouseInputOutputItems.forEach(function (
                        element
                      ) {
                        console.log(element);

                        complexPouringAdditiv = {
                          id: element.id,
                          articleId: element.articleId,
                          lot: element.lot,
                          bottlingOrProductionDate:
                            element.bottlingOrProductionDate,
                          validTo: element.validTo,
                          quantity: Number(element.quantity),
                          quantityUnitOfMeasure: {
                            id: element.quantityUnitOfMeasure.id,
                          },
                          vat: element.vat,
                          price: element.price,
                          currency: {
                            id: element.currency.id,
                          },
                        };

                        complexPouringAdditivPom = {
                          id: element.id,
                          articleId: {
                            id: element.articleId,
                            name: element.materialName,
                            unitOfMeasure: element.quantityUnitOfMeasure,
                          },
                          lot: element.lot,
                          bottlingOrProductionDate:
                            element.bottlingOrProductionDate,
                          validTo: element.validTo,
                          quantity: Number(element.quantity),
                          quantityUnitOfMeasure: element.quantityUnitOfMeasure,
                          vat: element.vat,
                          price: element.price,
                          currency: element.currency,
                          value: element.quantity * element.price,
                        };

                        _this.items_modal.push(complexPouringAdditiv);
                        _this.items_modal_pom.push(complexPouringAdditivPom);

                        _this.ukupna_vrednost =
                          _this.ukupna_vrednost +
                          element.quantity * element.price;
                      });
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  beforeMount() {
    serverBus.$on("wh_input", (id, tip_magacina, item) => {
      // console.log(item);

      this.warehouseID = id;
      this.warehouseType = tip_magacina;

      if (item !== null) {
        this.getAllArticles();
        this.getAllJediniceMere();

        this.edit_form = item.edit;
        this.executed_document = item.executed;

        this.number = item.number;
        this.getAllItem(item.id);
      }
    });
  },
  mounted() {
    this.clearInit();
    this.getAllEmployees();
    this.getAllSellers();
    // this.setTime();
    // this.setDate();
  },

  destroyed() {
    serverBus.$off("wh_input");
  },
};
</script>

<style lang="scss" scoped>
@import "./parts/../../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}
#Odustani_dugme {
  text-align: right !important;
}

.menuable__content__active {
  background-color: white;
}
</style>
